<template>
  <div class="resource-download-page">
    <el-card class="rd-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="$emit('switch-view', 'MemberCenter')" style="margin-bottom:10px;">
        返回会员中心
      </el-button>
      <div class="rd-header-row">
        <el-input v-model="search" placeholder="搜索资源" class="rd-search" clearable @keyup.enter.native="fetchData" />
        <el-select v-model="category" placeholder="全部分类" class="rd-select" @change="fetchData">
          <el-option label="全部分类" value="" />
          <el-option v-for="cat in categories" :key="cat" :label="cat" :value="cat" />
        </el-select>
      </div>
    </el-card>
    <el-card class="rd-table-card">
      <el-table :data="resourceList" stripe style="width: 100%">
        <el-table-column prop="name" label="文件名" min-width="180"/>
        <el-table-column prop="type" label="类型" width="80"/>
        <el-table-column prop="size" label="大小" width="80"/>
        <el-table-column prop="date" label="上传时间" width="140"/>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button type="primary" size="mini" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="page"
        @current-change="fetchData"
        class="rd-pagination"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ResourceDownload',
  data() {
    return {
      search: '',
      category: '',
      categories: ['动物套件', '文创产品', '建筑套件', '卡通人物'],
      resourceList: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      // 与激光切割机相关的文创课程资源示例
      const all = [
        { name: '激光切割机动物拼装套件.dxf', type: '动物套件', size: '1.2M', date: '2025-04-01' },
        { name: '激光切割机文创钥匙扣设计.cdr', type: '文创产品', size: '0.8M', date: '2025-03-28' },
        { name: '激光切割机建筑模型套件.ai', type: '建筑套件', size: '2.1M', date: '2025-03-20' },
        { name: '激光切割机卡通人物拼装套件.dxf', type: '卡通人物', size: '1.0M', date: '2025-03-15' },
        { name: '激光切割机创意灯具设计.svg', type: '文创产品', size: '0.7M', date: '2025-03-10' },
        { name: '激光切割机动物面具套件.dxf', type: '动物套件', size: '0.9M', date: '2025-03-06' },
        { name: '激光切割机文创台历设计.cdr', type: '文创产品', size: '1.1M', date: '2025-03-01' },
        { name: '激光切割机建筑桥梁套件.ai', type: '建筑套件', size: '2.3M', date: '2025-02-25' },
        { name: '激光切割机卡通动物拼装套件.dxf', type: '动物套件', size: '1.4M', date: '2025-02-20' },
        { name: '激光切割机创意手机支架设计.svg', type: '文创产品', size: '0.6M', date: '2025-02-15' },
        { name: '激光切割机创意书签设计.cdr', type: '文创产品', size: '0.5M', date: '2025-02-10' },
      ];
      let filtered = all.filter(item => {
        const matchSearch = !this.search || item.name.includes(this.search);
        const matchCat = !this.category || item.type === this.category;
        return matchSearch && matchCat;
      });
      this.total = filtered.length;
      const start = (this.page - 1) * this.pageSize;
      this.resourceList = filtered.slice(start, start + this.pageSize);
    },
    download(row) {
      this.$message.success(`正在下载：${row.name}`);
      // 生产环境可用真实下载接口
    },
  }
};
</script>

<style scoped>
.resource-download-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 0;
}
.rd-header {
  margin-bottom: 18px;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.rd-header-row {
  display: flex;
  align-items: center;
  gap: 18px;
}
.rd-search {
  width: 260px;
}
.rd-select {
  width: 160px;
}
.rd-table-card {
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  margin-bottom: 18px;
}
.rd-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
